import { NavLink } from 'react-router-dom';
import { useUIStore, useNewsStore } from '../../stores';
import { cn } from '../../utils';
import { useEffect } from 'react';

// 导航项配置（badge 将动态设置）
const getNavItems = (newsCount?: number) => [
  {
    section: '数据',
    items: [
      { to: '/', icon: 'chart', label: '行情总览' },
      { to: '/trend', icon: 'trend', label: '价格走势' },
      { to: '/compare', icon: 'compare', label: '品类对比' },
    ],
  },
  {
    section: '信息',
    items: [
      { to: '/news', icon: 'news', label: '行业新闻', badge: newsCount },
      { to: '/advice', icon: 'advice', label: '采购建议' },
      { to: '/knowledge', icon: 'knowledge', label: '专业知识' },
    ],
  },
  {
    section: '系统',
    items: [
      { to: '/settings', icon: 'settings', label: '设置' },
    ],
  },
];

const icons: Record<string, React.ReactNode> = {
  chart: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  trend: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <line x1="18" y1="20" x2="18" y2="10" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="20" x2="12" y2="4" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="6" y1="20" x2="6" y2="14" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  compare: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="3" y1="9" x2="21" y2="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="9" y1="21" x2="9" y2="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  news: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="14 2 14 8 20 8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16" y1="13" x2="8" y2="13" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16" y1="17" x2="8" y2="17" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  advice: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="16" x2="12" y2="12" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  knowledge: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  settings: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

export function Sidebar() {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed);
  const toggleSidebarCollapsed = useUIStore((state) => state.toggleSidebar);
  const sidebarMobileOpen = useUIStore((state) => state.sidebarMobileOpen);
  const newsItems = useNewsStore((state) => state.items);
  const setNewsItems = useNewsStore((state) => state.setItems);

  // 加载新闻数量
  useEffect(() => {
    async function loadNewsCount() {
      try {
        const result = await import('../../services/api').then(m => m.newsApi.getList({ limit: 100 }));
        setNewsItems(result.items);
      } catch {
        // 静默失败
      }
    }
    if (newsItems.length === 0) {
      loadNewsCount();
    }
  }, []);

  // 动态获取新闻数量
  const newsCount = newsItems.length || 0;
  const navItems = getNavItems(newsCount > 0 ? newsCount : undefined);

  return (
    <nav
      className={cn(
        'fixed top-[56px] left-0 bottom-0 bg-surface border-r border-border overflow-y-auto transition-all duration-normal z-50',
        sidebarCollapsed ? 'w-[64px]' : 'w-[240px]',
        // Mobile: hidden by default, shown when sidebarMobileOpen
        'max-lg:w-[280px] max-lg:max-w-[82vw]',
        !sidebarMobileOpen && 'max-lg:-translate-x-full max-lg:pointer-events-none',
        sidebarMobileOpen && 'max-lg:translate-x-0 max-lg:pointer-events-auto'
      )}
    >
      <div className="p-4 space-y-6">
        {navItems.map((section) => (
          <div key={section.section}>
            {(!sidebarCollapsed || sidebarMobileOpen) && (
              <div className="text-xs font-semibold text-text-muted uppercase tracking-wider px-3 mb-2">
                {section.section}
              </div>
            )}
            <div className="space-y-1">
              {section.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-fast',
                      isActive
                        ? 'bg-primary text-white'
                        : 'text-text-secondary hover:bg-primary/5 hover:text-text'
                    )
                  }
                >
                  {icons[item.icon]}
                  {(!sidebarCollapsed || sidebarMobileOpen) && (
                    <>
                      <span className="flex-1">{item.label}</span>
                      {item.badge && (
                        <span className="text-xs bg-accent text-white px-2 py-0.5 rounded-full font-semibold">
                          {item.badge}
                        </span>
                      )}
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* 折叠按钮 - 桌面端显示 */}
      <div className="hidden lg:block absolute bottom-4 left-0 right-0 px-4">
        <button
          onClick={toggleSidebarCollapsed}
          className={cn(
            'w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-fast',
            'text-text-secondary hover:bg-primary/5 hover:text-text',
            sidebarCollapsed && 'justify-center'
          )}
          title={sidebarCollapsed ? '展开侧边栏' : '收起侧边栏'}
        >
          <svg
            className={cn('w-[18px] h-[18px] transition-transform', sidebarCollapsed && 'rotate-180')}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <polyline points="15 18 9 12 15 6" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {!sidebarCollapsed && <span>收起侧边栏</span>}
        </button>
      </div>
    </nav>
  );
}
